/** API client for derived per-tool usage (last-used + weekly count). */
import { apiClient } from '../api-client'

export interface ToolUsage {
  tool_id: string
  last_used_at: string | null
  count_this_week: number
}

export async function getDashboardToolUsage(): Promise<ToolUsage[]> {
  const response = await apiClient.get<{ success: boolean; tools: ToolUsage[] }>(
    '/api/v1/dashboard/tool-usage?days=7',
  )
  return response.data.tools
}
